// Auto-generated by scripts/gen-manifest.js. Do not edit by hand —
// re-run `npm run gen-manifest` after adding/removing references.
//
// Per-marc data needed to render a marc photo in the picker modal in
// the same pose as the easel + onion overlay: canvas-virtual dims plus
// the marc's displayBox / transform / naturalSize. Saves the picker
// from fetching every reference JSON on open (those carry full base64
// region masks and run hundreds of KB each).
export const MARC_PICKER_DATA = {
  "001": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": -10.099714181496886,
        "ty": 105.82139197322951,
        "scale": 1.0293913074511956,
        "rot": 0
      },
      "naturalSize": {
        "width": 250,
        "height": 250
      }
    }
  },
  "002": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 190.13064133016627,
        "w": 792,
        "h": 637.7387173396675
      },
      "transform": {
        "tx": 18.209938017003964,
        "ty": 158.08462238849935,
        "scale": 1.275508366678405,
        "rot": -0.23025322353298983
      },
      "naturalSize": {
        "width": 421,
        "height": 339
      }
    }
  },
  "003": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 34.76501305483026,
        "w": 792,
        "h": 948.4699738903395
      },
      "transform": {
        "tx": 9.185672097391773,
        "ty": 42.09384944916758,
        "scale": 1.0285975820716986,
        "rot": 0
      },
      "naturalSize": {
        "width": 1149,
        "height": 1376
      }
    }
  },
  "004": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 104.08999999999997,
        "w": 792,
        "h": 809.82
      },
      "transform": {
        "tx": 24.065178400472035,
        "ty": 77.66360777741988,
        "scale": 1.0751987243813756,
        "rot": 0
      },
      "naturalSize": {
        "width": 400,
        "height": 409
      }
    }
  },
  "006": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": -7.689256002737537,
        "ty": 107.5929933777718,
        "scale": 1.0225298010330004,
        "rot": 0
      },
      "naturalSize": {
        "width": 350,
        "height": 350
      }
    }
  },
  "007": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": 26.985163314663595,
        "ty": 90.30908144195823,
        "scale": 1.0829932864749525,
        "rot": -0.21020383656264788
      },
      "naturalSize": {
        "width": 200,
        "height": 200
      }
    }
  },
  "008": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": -4.61230212042625,
        "ty": 97.69322522100144,
        "scale": 1.0727574527513921,
        "rot": 0
      },
      "naturalSize": {
        "width": 153,
        "height": 153
      }
    }
  },
  "009": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 118.95488721804514,
        "w": 792,
        "h": 780.0902255639097
      },
      "transform": {
        "tx": 7.675108337599106,
        "ty": 74.46623545613437,
        "scale": 1.142075501764111,
        "rot": 0
      },
      "naturalSize": {
        "width": 133,
        "height": 131
      }
    }
  },
  "010": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": -0.7639739174753026,
        "ty": 125.9000720669022,
        "scale": 1,
        "rot": 0
      },
      "naturalSize": {
        "width": 460,
        "height": 460
      }
    }
  },
  "011": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": -7.385081202261259,
        "ty": 86.53419381921645,
        "scale": 1.1022162577580488,
        "rot": 0
      },
      "naturalSize": {
        "width": 161,
        "height": 161
      }
    }
  },
  "012": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 106.01176470588234,
        "w": 792,
        "h": 805.9764705882353
      },
      "transform": {
        "tx": 4.378702360344559,
        "ty": 112.60126683677656,
        "scale": 1.0261143282463372,
        "rot": 0
      },
      "naturalSize": {
        "width": 1020,
        "height": 1038
      }
    }
  },
  "013": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": 19.870395686927083,
        "ty": 95.5250350146897,
        "scale": 1.0667967071952114,
        "rot": 0
      },
      "naturalSize": {
        "width": 340,
        "height": 340
      }
    }
  },
  "014": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": -44.233820674769184,
        "ty": 22.09262510250433,
        "scale": 1.231976117945633,
        "rot": 0
      },
      "naturalSize": {
        "width": 440,
        "height": 440
      }
    }
  },
  "015": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 113,
        "w": 792,
        "h": 792
      },
      "transform": {
        "tx": -5.100233282404565,
        "ty": 118.77672266970191,
        "scale": 1,
        "rot": 0
      },
      "naturalSize": {
        "width": 220,
        "height": 220
      }
    }
  },
  "016": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 116.19490445859873,
        "w": 792,
        "h": 785.6101910828025
      },
      "transform": {
        "tx": 13.384633738294859,
        "ty": 106.13341506529716,
        "scale": 1.0347449045627557,
        "rot": -0.008361093920056621
      },
      "naturalSize": {
        "width": 2355,
        "height": 2336
      }
    }
  },
  "017": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 112.48638132295719,
        "w": 792,
        "h": 793.0272373540856
      },
      "transform": {
        "tx": 19.73348799984997,
        "ty": 93.4148906265753,
        "scale": 1.0678035637060619,
        "rot": 0
      },
      "naturalSize": {
        "width": 771,
        "height": 772
      }
    }
  },
  "018": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 100.68,
        "w": 792,
        "h": 816.64
      },
      "transform": {
        "tx": 15.112354734062322,
        "ty": 66.35420033142239,
        "scale": 1.1239423889470417,
        "rot": 0
      },
      "naturalSize": {
        "width": 900,
        "height": 928
      }
    }
  },
  "019": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 52.674509803921524,
        "y": 0,
        "w": 686.650980392157,
        "h": 1018
      },
      "transform": {
        "tx": 2.317505271431031,
        "ty": 10.345510058993057,
        "scale": 1.154539184890988,
        "rot": -0.044358694248405106
      },
      "naturalSize": {
        "width": 172,
        "height": 255
      }
    }
  },
  "020": {
    "canvas": {
      "width": 792,
      "height": 1018
    },
    "marc": {
      "displayBox": {
        "x": 0,
        "y": 129.73239436619718,
        "w": 792,
        "h": 758.5352112676056
      },
      "transform": {
        "tx": 0.9549673968441283,
        "ty": 135.71147784040446,
        "scale": 1,
        "rot": 0
      },
      "naturalSize": {
        "width": 355,
        "height": 340
      }
    }
  }
};
